import app from "@/main";

export default {
  setOldTokens(state, { access, refresh, status }) {
    state.tokens.access = access;
    state.tokens.refresh = refresh;
    if (status) state.status = status;
  },
  setNewTokens(state, { access, refresh, status }) {
    state.tokens.access = access;
    state.tokens.refresh = refresh;
    if (status) state.status = status;
    app.prototype.$DbStorage.setItem("rocketfuel_access", access);
    app.prototype.$DbStorage.setItem("rocketfuel_refresh", refresh);
    if (status) app.prototype.$DbStorage.setItem("rocketfuel_status", status);
  },
  setPlaidLinkTokens(state, token) {
    state.plaidToken = token;
  },
  setStatus(state, status) {
    app.prototype.$DbStorage.setItem("rocketfuel_status", status);
    state.status = status;
  },
  logOut() {
    try {
      app.prototype.$DbStorage.removeItem("rocketfuel_access");
      app.prototype.$DbStorage.removeItem("rocketfuel_refresh");
      app.prototype.$DbStorage.removeItem("rocketfuel_status");
      app.prototype.$DbStorage.removeItem("isGuestUser");
    } catch (e) {
      // no log
    }
    this.state.auth.tokens.access = "";
    this.state.auth.tokens.refresh = "";
    this.state.auth.status = 0;
    this.state.isGuestUser = false;
    this.state.user.stockExchanges = {};
    this.state.user.selectedExchange = {};
    this.state.user.stocks = {};
    this.state.user.userInfo = {};
    // this.state.user.cart = {};
    this.state.user.txs = {};
    this.state.user.stores = {};
    this.state.user.extensionHeight = "100px";
    this.state.user.settings = {};
    this.state.user.currencies = [];
    this.state.user.displayCurrency = {};
    this.state.ssoUser = false;
    // this.state.user.marketInfo = {};
  },
  setRestoreData(state, data) {
    state.restoredData = data;
  },
  setUserId(state, data) {
    state.userId = data;
  },
  setGuestStatus(state, data) {
    state.isGuestUser = data;
    app.prototype.$DbStorage.setItem("isGuestUser", data);
  },
  setUserEmail(state, data) {
    state.userEmail = data;
  },
  setTemporaryTokens(state, { access, refresh }) {
    state.tokens.tempAccess = access;
    state.tokens.tempRefresh = refresh;
  },
  changePaymentCompleted(state) {
    state.paymentCompleted = 1;
  },
  ssoUser(state, data) {
    state.ssoUser = data;
  }
};
